import { useMutation } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest } from '../utils/graphqlClient';

const upsertGuestDetailsMutation = graphql(/* GraphQL */ `
  mutation guestDetail($input: GuestDetailsInput!) {
    guestDetail(guestDetails: $input)
  }
`);

// Type for each rental gear item in the input
export type DiveGearItem = {
  size?: string;
  price: number;
  quantity: number;
};

// The input type expected by the GraphQL mutation and backend service
export type GuestDetailsInput = {
  bookingId: number;
  guestNumber: number; // Used to upsert the correct guest row
  fullName: string;
  gender: string;
  email: string;
  phone: string;
  certificateLevel: string;
  certificateNumber: string;
  certifyingAgency: string;
  countryOfIssuance: string;
  passportNumber: string;
  expiryDate?: string;
  emergencyContactName: string;
  emergencyContactPhone: string;
  airportTransferNeeded: boolean;
  arrivalFlightNumber: string;
  arrivalDate?: string;
  selfTransferUponArrival: boolean;
  departureFlightNumber: string;
  departureDate?: string;
  selfTransferUponDeparture: boolean;
  rentalGear: {
    key: string;
    value: {
      size?: string;
      price: number;
      quantity: number;
    };
  }[];
};

const useUpsertGuestDetails = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const mutation = useMutation({
    mutationFn: async (input: GuestDetailsInput) => {
      if (!isAuthenticated) {
        throw new Error('User must be authenticated to upsert guest details');
      }
      return graphqlRequest(
        upsertGuestDetailsMutation,
        { input },
        getAccessTokenSilently,
      );
    },
  });

  return mutation;
};

export default useUpsertGuestDetails;
